module.exports = __webpack_public_path__ + "static/turtle-creek-house34-65f95961977c95a60789ef98c5e010c6.jpg";